import { render, staticRenderFns } from "./create-edit-client-notification-modal.vue?vue&type=template&id=54669870"
import script from "./create-edit-client-notification-modal.vue?vue&type=script&lang=js"
export * from "./create-edit-client-notification-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports